import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useMemo } from "react";
import { ScheduledTimeOffItem } from "./time-off-item.js";

export const ScheduledTimeOffList = ({
  timeOffs,
  handleEdit,
  handleDelete,
  franchise,
  loading
}) => {

  if (!timeOffs?.length) return null;
  const canManageTimeOffs = useMemo(() => {
    return franchise?.settings?.canManageTimeOff;
  },[franchise]);
  return (
       <TableContainer  component={Paper}>
         <Table sx={{ minWidth: 650 }} >
         <TableHead>
            <TableRow >
              <TableCell className='tw-font-bold'>Dates</TableCell>
              <TableCell className='tw-font-bold'>Times</TableCell>
              {/* <TableCell className='tw-font-bold'>Paid</TableCell> */}
              <TableCell className='tw-font-bold'>Status</TableCell>
              <TableCell className="tw-font-bold"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {
            timeOffs.map((item) => (
             <ScheduledTimeOffItem
             loading={loading}
              franchise={franchise}
              key={item.id}
              row={item}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              />
            ))
          }
        </TableBody>
        </Table>
        </TableContainer>
  );
};